import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonServices, TopBarService } from '@asamco/base';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Link } from '../../interfaces/link.interface';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { LinkEditGeneralComponent } from '../link-edit-general/link-edit-general.component';
import { LinkEditLoginDetailsComponent } from '../link-edit-login-details/link-edit-login-details.component';
import { LinkEditSettingsComponent } from '../link-edit-settings/link-edit-settings.component';
import { LinkLogComponent } from '../link-log/link-log.component';
import { LinkEditSchedularComponent } from '../link-edit-schedular/link-edit-schedular.component';
import { LinkEditSetupComponent } from '../link-edit-setup/link-edit-setup.component';
import { LinkEditSupportComponent } from '../link-edit-support/link-edit-support.component';
import { LinkEditStatisticsComponent } from '../link-edit-statistics/link-edit-statistics.component';
import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ALTabsComponent } from '@asamco/application-link/shared';

@Component({
    selector: 'al-link-edit',
    templateUrl: './link-edit.component.html',
    styleUrls: ['./link-edit.component.scss'],
    standalone: true,
    imports: [
        ALTabsComponent,
		AsyncPipe,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        LinkEditStatisticsComponent,
        LinkEditSupportComponent,
        LinkEditSetupComponent,
        LinkEditSchedularComponent,
        LinkLogComponent,
    ],
})
export class LinkEditComponent implements OnInit, OnDestroy {
	/** The general edit tab */
	@ViewChild(LinkEditGeneralComponent)
	editGeneral: LinkEditGeneralComponent;

	/** The login details tab */
	@ViewChild(LinkEditLoginDetailsComponent)
	loginDetails: LinkEditLoginDetailsComponent;

	/** Settings tab */
	@ViewChild(LinkEditSettingsComponent)
	settings: LinkEditSettingsComponent;

	/** The link to edit */
	@Input()
	link: Link;

	/** The link information*/
	@Input()
	linkInfo: MarketPlaceItem;

	/** Array containing the tabs */
	public tabInfo = [];
	public selectedTab$ = new BehaviorSubject<number>(1);

	private destroy$ = new Subject<void>();

	constructor(private topBarService: TopBarService, private cs: CommonServices, private route: ActivatedRoute) {}

	ngOnInit(): void {
		this.initTabs();
		this.route.queryParamMap
			.pipe(
				map(r => r.get('tab')),
				takeUntil(this.destroy$)
			)
			.subscribe(sTabIndex => {
				const tabIndex = Number(sTabIndex);
				if (tabIndex >= 0 && tabIndex <= this.tabInfo.length) this.selectedTab$.next(tabIndex);
			});
	}

	ngOnDestroy(): void {
		this.topBarService.clearAllButtons();
		this.destroy$.next();
		this.destroy$.complete();
	}

	/** Gets array of steps */
	public getArray() {
		return Array(this.tabInfo.length).sort((a, b) => (a.id > b.color) ? 1 : -1)
	}

	/** Initializes the tabs */
	private initTabs() {
		this.tabInfo = [
			{
				id: 1,
				text: 'Statistics',
				icon: 'far fa-info-circle',
			},
			// {
			// 	id: 1,
			// 	text: 'Pricing',
			// 	icon: 'far fa-wallet',
			// },
		];

		if (this.link.id && this.link.id > 0) {
			this.tabInfo.push({
				id: 2,
				text: 'Setup',
				icon: 'far fa-cog',
			});
			if (!this.linkInfo.frontendPage) {
				this.tabInfo.push({
					id: 3,
					text: 'Scheduler',
					icon: 'far fa-calendar',
				});
			}
			if (!this.linkInfo.frontendPage) {
			this.tabInfo.push({
				id: 4,
				text: 'Logs',
				icon: 'far fa-bars',
			});

		}

		this.tabInfo.push({
			id: 5,
			text: 'Support',
			icon: 'far fa-headset',
	})
		}
	}
}
